import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { Label as BaseLabel } from '../FormStyles';
import { Checked } from '../../assets';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled(BaseLabel)`
  margin: 0;
  font-weight: 500;
  color: ${themeGet('colors.black.100')};
  margin: 0 0 0 10px;
`;

const Checkmark = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid ${themeGet('colors.black.60')};
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 20px;
  width: 20px;

  &:checked + ${Checkmark} {
    background-color: ${themeGet('colors.primary.100')};
    background-image: url(${Checked});
    background-repeat: no-repeat;
    background-position: center;
    border: 0;
  }
`;

export default function Checkbox({ name, label, onChangeHandler, value, checked }) {
  return (
    <Wrapper>
      <Input
        id={value}
        type="checkbox"
        value={value}
        name={name}
        onChange={onChangeHandler}
        checked={checked}
        data-value={value}
      />
      <Checkmark onClick={onChangeHandler} data-value={value}/>
      <Label htmlFor={name}>{label}</Label>
    </Wrapper>
  );
}
